export default "__VITE_ASSET__DUPfz$u0__"